export const container = `
  flex flex-col flex-1 overflow-hidden box-border
`;

// Calculate height without the attribution and tabsroot
export const tabsRoot = `
  overflow-y-auto flex flex-col
`;
